import { useState, createContext, useContext, useMemo, ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useMount } from 'react-use';
import { SearchResponse } from './api';
import { SkinningUser } from './types';

type ContextValue =
  | (SkinningUser & {
      setSelected: (user: SkinningUser) => void;
    })
  | {
      setSelected: (user: SkinningUser) => void;
    };

const Context = createContext<ContextValue>({
  setSelected: () => undefined,
});

export const useSetSelected = () => {
  const { setSelected } = useContext(Context);
  return setSelected;
};

export const useSelected: () => SkinningUser | null = () => {
  const context = useContext(Context);

  const appUser = useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { setSelected, ...rest } = context;
    return rest;
  }, [context]);

  return Object.keys(appUser).length > 0 ? (appUser as SkinningUser) : null;
};

export const SelectedSkinningUserProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [appUser, setAppUser] = useState<SkinningUser>();
  const params = useParams();
  const searchResult = JSON.parse(
    sessionStorage.getItem('skinningUserSearchResult') || 'null'
  ) as SearchResponse | null;

  useMount(() => {
    if (params['*']) {
      const user = searchResult?.profiles.filter(
        (u) => u.userId === params['*']
      )[0];
      setAppUser(user);
    }
  });

  const context = useMemo(() => {
    return { ...appUser, setSelected: setAppUser };
  }, [appUser]);

  return <Context.Provider value={context}>{children}</Context.Provider>;
};
